import { useTranslation } from "react-i18next"

import { StatusBadge, type StatusTone } from "@/components/status-badge"
import type { OTStage } from "@/features/transit/api/types"

const STAGE_TONES: Record<OTStage, StatusTone> = {
  CREATED: "warning",
  ANALYSE: "warning",
  FORMULE: "warning",
  EMPOTAGE: "warning",
  EMBARQUEMENT: "info",
  REMISE: "success",
  TERMINER: "muted",
}

interface StageChipProps {
  stage: OTStage
  archived?: boolean
}

export function StageChip({ stage, archived }: StageChipProps) {
  const { t } = useTranslation("transit")

  if (archived) {
    return (
      <StatusBadge tone="muted">{t("stageBadge.archived")}</StatusBadge>
    )
  }

  if (stage === "TERMINER") {
    return (
      <StatusBadge tone="success">{t("stageBadge.sailed")}</StatusBadge>
    )
  }

  return (
    <StatusBadge tone={STAGE_TONES[stage]}>{t(`stages.${stage}`)}</StatusBadge>
  )
}
